const comparator = new Intl.Collator();


function getScrollbarSize() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);

    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);

    // Calculating difference between container's full width and the child width
    const width = (outer.offsetWidth - inner.offsetWidth);
    // Calculating difference between container's full width and the child width
    const height = (outer.offsetHeight - inner.offsetHeight);

    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);

    return {
        width: width < 13 ? 13: width,
        height: height < 13 ? 13: height
    };
}


function compareItems(column, itemA, itemB, rowA, rowB, order, prop) {
    let sorted = 0;
    if(column?.comparator) {
        sorted = column.comparator(itemA, itemB, rowA, rowB, prop);
        if(order === 'desc') {
            sorted = sorted * -1;
        }
    } else {
        if(typeof(itemA) == 'string'){
            sorted = keySortStr(itemA, itemB, order);
        }else {
            sorted = keySort(itemA, itemB, order);
        }
    }
    return sorted;
}
function keySort(a, b, dir) {
    const d = dir === 'asc' ? 1 : -1;
    if (a === b) {
        return 0;
    }
    return a > b ? 1 * d : -1 * d;
}
function keySortStr(a, b, dir) {
    const d = dir === 'asc' ? 1 : -1;
    let ord = comparator.compare(a?.toLowerCase() ?? "", b?.toLowerCase() ?? "");
    if(ord === 0){
        ord = comparator.compare(a ?? "", b ?? "");
    }
    return ord * d;
}

function sortSource(source, columns){
    let colByProp = {};
    let extSorting = [];

    for(let col of columns){
        // @ts-ignore
        colByProp[col.prop] = col;
        if(col.order){
            extSorting.push({prop: col.prop, order: col.order, col:col});
        }
    }

    extSorting.push({prop: 'eid', order: 'asc', col:null});
    extSorting.push({prop: 'id', order: 'asc', col:null});

    return [...source].sort((a, b) => {
        let sorted = 0;
        for (let propI in extSorting) {
            let prop = extSorting[propI].prop;
            let order = extSorting[propI].order;
            let col = extSorting[propI].col;

            const itemA = a[prop];
            const itemB = b[prop];

            sorted = compareItems(col, itemA, itemB, a, b, order, prop);
            if(sorted !== 0) {
                return sorted;
            }
        }
        return sorted;
    });

}

function collectTexts(el){
    let text = "";
    for(let child of el?.children){
        text += child.innerText ? child.innerText + " " : "";
        text += collectTexts(child);
    };
    return text;
}

const DEBUG = false;
export {DEBUG, getScrollbarSize, sortSource, collectTexts};